export interface HalfYearPeriod {
	label: string
	van: string
	tot: string
}

/**
 * The `count` most recent halfjaren (Jan-Jun, Jul-Dec) that have fully passed on `today`,
 * newest first. This is the verslagperiode of the CBS beleidsinformatie jeugd.
 */
const halfYearPeriods = (today: Date, count: number): HalfYearPeriod[] => {
	let year = today.getFullYear();
	let secondHalf = today.getMonth() >= 6; // the current half is not finished yet
	const periods: HalfYearPeriod[] = [];
	for (let i = 0; i < count; i++) {
		secondHalf = !secondHalf;
		if (secondHalf) year--;
		periods.push(secondHalf
			? {label: `${year} juli - december`, van: `${year}-07-01`, tot: `${year}-12-31`}
			: {label: `${year} januari - juni`, van: `${year}-01-01`, tot: `${year}-06-30`});
	}
	return periods;
};

export default halfYearPeriods;
